/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import CashAccountList from "./CashAccountList";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";
import { permissionCheck } from "../../../utils/permission";

const FundsAccountDetail = (props) => {
  const { permissions } = useSelector(
    (store) => ({
      permissions: store.Profile.permissions,
    }),
  );
  const history = useHistory();
  const [targetPermission, setTargetPermission] = useState(null)

  useEffect(() => {
    if (!isEmpty(permissions)) {
      const permission = permissions.find(p => p.code === 'FUND_BANK_HISTORY')
      setTargetPermission(permission)
      if (isEmpty(permission)) {
        permissionCheck(history, "FUND_BANK_HISTORY")
      }
    }
  }, [permissions])

  return (
    !isEmpty(targetPermission) && (
      <CashAccountList  permission={targetPermission} />
    ));
};

export default FundsAccountDetail;
